import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import Select from 'react-select';
export const BaseSelectAsync = ({
  error,
  label,
  name,
  loadOptions,
  options,
  control,
  placeholder,
  multi,
  defaultValue,
  onInputChange,
  handlerOnChange,
  isDisabled
}) => {
  return (
    <div className="my-4">
      <label
        htmlFor={name}
        className="text-slate-600 text-sm capitalize leading-tight tracking-normal">
        {label}
      </label>
      <div className="my-1">
        <Controller
          name={name}
          rules={{
            required: true
          }}
          isMulti={multi}
          defaultValue={defaultValue}
          control={control}
          render={({ field: { onChange } }) => (
            <Select
              className={'react-select bg-red-200'}
              classNamePrefix={'react-select'}
              isMulti={multi}
              placeholder={placeholder}
              options={options}
              onChange={(v, actionMeta) => {
                handlerOnChange(v, actionMeta);
                onChange(v, actionMeta);
              }}
              defaultValue={defaultValue}
              loadOptions={loadOptions}
              onInputChange={onInputChange}
              // isClearable
              isDisabled={isDisabled}
            />
          )}
        />
      </div>

      {error && <span className="text-red-500 text-xs">{error.message}</span>}
    </div>
  );
};

BaseSelectAsync.propTypes = {
  error: PropTypes.object,
  control: PropTypes.any,
  label: PropTypes.string,
  options: PropTypes.array,
  validation: PropTypes.object,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  multi: PropTypes.bool,
  defaultValue: PropTypes.any,
  onInputChange: PropTypes.func,
  handlerOnChange: PropTypes.func,
  isDisabled: PropTypes.bool
};
BaseSelectAsync.defaultProps = {
  multi: false,
  isDisabled: false
};
